module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_flower_aqua-dafa80ea99bec0f12c42be14c296407c.jpg";